import { useNonComponentHook } from '@/composables/useHookPair.js';

export const [triggerChapterClicked, onChapterClickedToggle] = useNonComponentHook();
